const selectApiLoadingStatus = (state, type) =>
	!!state.general.apiStatus.loading[type];

const generalSelectors = {
	selectApiLoadingStatus,
};

export default generalSelectors;
